
<div class="bar-wrapper">
  <div *ngIf="showZeroLine" class="neutral-zone" [ngStyle]="getNeutralZoneStyle()"></div>

  <div *ngIf="showZeroLine" class="bar"
       [style.marginLeft.%]="!isNegative ? neutralZonePercent : 0"
       [style.marginRight.%]="isNegative ? neutralZonePercent : 0"
       [ngClass]="isNegative ? 'bar-segment-right-border-radius' : 'bar-segment-left-border-radius' ">
    <div *ngFor="let segment of segments"
         class="bar-segment"
         [style.width]="getWidth(segment.value)"
         [style.backgroundColor]="segment.color">
    </div>

    <div class="progress-dotted-line_total" [style.left.%]="getTotalWidth() || 0">
      <div class="solid-total-bar-label" *ngIf="showLabel">
        <span style="white-space: nowrap;">Totaal: <b>{{ total | number:'1.0-0' }}</b></span>
      </div>
    </div>

  </div>

  <div *ngIf="!showZeroLine" class="bar">
    <div *ngFor="let segment of segments"
         class="bar-segment"
         [style.width]="getWidth(segment.value)"
         [style.backgroundColor]="segment.color">

    </div>

    <div class="progress-dotted-line" [style.left.%]="getTotalWidth() || 0">
      <div class="bar-label" *ngIf="showLabel">
        <span style="white-space: nowrap;">Totaal: <b style="color:black">{{ total | number:'1.0-0' }}</b></span>
      </div>
    </div>

  </div>

  <div *ngIf="showZeroLine" class="zero-line-wrapper" [ngStyle]="zeroLineWrapperStyle">
    <div class="zero-line"></div>
    <div class="zero-label">0</div>
    <div class="zero-tooltip" [innerHTML]="'CO2 neutraal' | fixDimensions"></div>

  </div>

</div>